'use client';

import type { User } from '@/api/entities';
import { getUserData } from '@/api/user';
import { isActionError } from '@/lib/error';
import { useQuery } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';
interface UserContextType {
  user: User | null | undefined;
}
const UserContext = createContext<UserContextType | undefined>(undefined);
export function UserProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    data: user
  } = useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const response = await getUserData();
      if (isActionError(response)) {
        throw new Error(response.error);
      }
      return response;
    }
  });
  return <UserContext value={{
    user
  }} data-sentry-element="UserContext" data-sentry-component="UserProvider" data-sentry-source-file="user-provider.tsx">
      {children}
    </UserContext>;
}
export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}